/* istanbul ignore file */
import { MultiSelectInputFilter, ConditionProps } from 'framework/list';
import { MultiSelectField } from 'domain/shared/core/input';
import { useVacancyGroupService } from 'domain/shared/newVacancy';

const VacancyGroupFilter = ({ label, ...props }: Omit<ConditionProps, 'children'> & { label: string }) => {
  return (
    <MultiSelectInputFilter {...props}>
      <MultiSelectField
        {...props}
        label={label}
        useService={useVacancyGroupService}
        searchString="searchString"
        noOptionLabel="Vacancy group"
        buildLabelCallback={group => group.searchString}
      />
    </MultiSelectInputFilter>
  );
};

export default VacancyGroupFilter;
